import React from 'react';
import { bool, shape, string } from 'prop-types';

const FuelPumpColor = ({
  className = 'icon',
  color = '#696f88',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.50084 2.57129H9.00084C10.0937 2.57129 10.9294 3.407 10.9294 4.49986V14.7856H2.57227V4.49986C2.57227 3.407 3.40798 2.57129 4.50084 2.57129ZM9.64369 4.49986C9.64369 4.11415 9.38655 3.857 9.00084 3.857H4.50084C4.11512 3.857 3.85798 4.11415 3.85798 4.49986V13.4999H9.64369V4.49986Z" fill="currentColor" />
    <path d="M9.64314 7.71436H3.85742V9.00007H9.64314V7.71436Z" fill="currentColor" />
    <path d="M8.35686 5.14307H5.14258V6.42878H8.35686V5.14307Z" fill="currentColor" />
    <path d="M13.5006 11.0571C12.7291 11.3143 12.2148 12.0214 12.2148 12.8571C12.2148 13.95 13.0506 14.7857 14.1434 14.7857C15.2363 14.7857 16.072 13.95 16.072 12.8571C16.072 12.0214 15.5577 11.3143 14.7863 11.0571V12.8571C14.7863 13.2428 14.5291 13.5 14.1434 13.5C13.7577 13.5 13.5006 13.2428 13.5006 12.8571V11.0571Z" fill="currentColor" />
    <path d="M10.9283 10.9288C10.1569 10.6716 9.64258 9.96448 9.64258 9.12877C9.64258 8.03591 10.4783 7.2002 11.5711 7.2002C12.664 7.2002 13.4997 8.03591 13.4997 9.12877C13.4997 9.96448 12.9854 10.6716 12.214 10.9288V9.12877C12.214 8.74305 11.9569 8.48591 11.5711 8.48591C11.1854 8.48591 10.9283 8.74305 10.9283 9.12877V10.9288Z" fill="currentColor" />
    <path d="M13.5006 9H12.2148V12.8571H13.5006V9Z" fill="currentColor" />
    <path d="M16.0709 7.71436H14.7852V12.8572H16.0709V7.71436Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M15.428 4.5C15.8137 4.5 16.0709 4.75714 16.0709 5.14286V7.71429C16.0709 8.1 15.8137 8.35714 15.428 8.35714C15.0423 8.35714 14.7852 8.1 14.7852 7.71429V5.14286C14.7852 4.75714 15.0423 4.5 15.428 4.5Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M13.1152 3.72861L14.0152 2.82861L15.8152 4.62861C16.0724 4.88576 16.0724 5.27147 15.8152 5.52861C15.5581 5.78576 15.1724 5.78576 14.9152 5.52861L13.1152 3.72861Z" fill="currentColor" />
  </svg>
);

FuelPumpColor.propTypes = {
  className: string,
  color: string,
  notUseClass: bool,
  style: shape({}),
};

export default FuelPumpColor;
